import { Form, FormLayout, Modal, TextField } from '@shopify/polaris';
import { useContext, useState } from 'react';
import { putCustomer } from '../../../services/customersService';
import { SET_OK, SET_ERROR } from '../../../context/ToastReducer';
import ToastContext from '../../../context/ToastContext';

export const EditCommerceRelationModal = ({ customer, active, id, onSave, onClose }) => {
  const [, dispatchToast] = useContext(ToastContext);

  const [dataForm, setDataForm] = useState(customer);

  const handleSubmit = () => {
    putCustomer(id, dataForm)
      .then((r) => {
        dispatchToast({ type: SET_OK, payload: r.data });
        onSave(dataForm);
        onClose();
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
      });
  };

  return (
    <Modal
      open={active}
      onClose={() => onClose()}
      title="Editar relación comercial"
      primaryAction={{
        content: 'Cambiar',
        onAction: handleSubmit,
      }}
    >
      <Modal.Section>
        {customer && (
          <Form>
            <FormLayout onSubmit={handleSubmit}>
              <TextField
                type="pvfExpression"
                label="PVF"
                placeholder={customer.pvfExpression}
                value={dataForm.pvfExpression}
                onChange={(e) => {
                  setDataForm({
                    ...dataForm,
                    pvfExpression: e,
                  });
                }}
                autoComplete="off"
              />
            </FormLayout>
          </Form>
        )}
      </Modal.Section>
    </Modal>
  );
};
